import Api from "../apiService";

class requisitesApi {
  index(companyId, params = {}) {
    const queryParts = [];

    Object.entries(params).forEach(([key, value]) => {
      if (value == null) return;

      if (Array.isArray(value)) {
        // Если значение — массив, добавляем каждый элемент с ключом [key]
        value.forEach((item) => {
          queryParts.push(`${key}[]=${encodeURIComponent(item)}`);
        });
      } else {
        // Если не массив — просто key=value
        queryParts.push(`${key}=${encodeURIComponent(value)}`);
      }
    });

    const queryString = queryParts.join("&");
    const url = `companies/${companyId}/requisites${
      queryString ? `?${queryString}` : ""
    }`;

    return Api.getRequest(url, {}, Api.authHeaders());
  }

  show(companyId, requisiteId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/requisites/${requisiteId}`,
      params,
      Api.authHeaders()
    );
  }

  create(companyId, requisiteData) {
    return Api.postRequest(
      `companies/${companyId}/requisites`,
      requisiteData,
      Api.authHeaders()
    );
  }

  update(companyId, requisiteId, requisiteData) {
    return Api.patchRequest(
      `companies/${companyId}/requisites/${requisiteId}`,
      requisiteData,
      Api.authHeaders()
    );
  }

  delete(companyId, requisiteId) {
    return Api.deleteRequest(
      `companies/${companyId}/requisites/${requisiteId}`,
      Api.authHeaders()
    );
  }
}

export default new requisitesApi();
